<div style="max-height: 90vh;">
    <div class="px-4 py-2 my-0 text-start">
        <h2 class="display-5 fw-bold text-center">Terms and Conditions</h2>
        <div class="col-12 mx-auto mx-4">
            <p class="lead mb-4">Login is required to access ACE. </p>
            <p class="text-start ">
                The information provided by the Alabama Department of Education (“we,” “us,” or “our”) on <a
                    target="_blank" href="{{environment.externalUrl.alsdeAce}}">{{environment.externalUrl.alsdeAce}}</a>
                (the “Site”) and our mobile application is for general informational purposes only. All information on
                the Site and our mobile application is provided in good faith; however, we make no representation or
                warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability or
                completeness of any information on the Site or our mobile application. UNDER NO CIRCUMSTANCE SHALL WE
                HAVE ANY LIABILITY FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR OUR
                MOBILE APPLICATION OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE AND OUR MOBILE APPLICATION.

                The Site and our mobile application may contain (or you may be sent through the Site or our mobile
                application) links to other websites or content belonging to or originating from third parties or links
                to websites and features in banners or other advertising. Such external links are not investigated,
                monitored, or checked for accuracy, adequacy, validity, reliability, availability or completeness by us.
                WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR THE ACCURACY OR RELIABILITY OF ANY
                INFORMATION OFFERED BY THIRD-PARTY WEBSITES LINKED THROUGH THE SITE OR ANY WEBSITE OR FEATURE LINKED IN
                ANY BANNER OR OTHER ADVERTISING. WE WILL NOT MONITOR ANY TRANSACTION BETWEEN YOU AND THIRD-PARTY
                PROVIDERS OF PRODUCTS AND SERVICES, NOR WILL WE BE RESPONSIBLE FOR ANY SUCH TRANSACTIONS.
            </p>
            <section class="example-section">
                <mat-checkbox class="example-margin" [(ngModel)]="checked">I agree with the terms and
                    conditions</mat-checkbox>
            </section>
        </div>
    </div>
    <mat-dialog-actions align="center">
        <button mat-button mat-dialog-close>Cancel</button>
        <button class="color-button-primary" mat-flat-button aria-label="Proceed" [disabled]="!checked"
            (click)="login()">Proceed</button>
    </mat-dialog-actions>
</div>